import React from 'react';
import { Role } from '../types/goals';
import { Users, UserCog } from 'lucide-react';
interface RoleSelectorProps {
  currentRole: Role;
  onChange: (role: Role) => void;
}
export function RoleSelector({
  currentRole,
  onChange
}: RoleSelectorProps) {
  return <div className="flex bg-slate-100 p-1 rounded-lg" data-id="element-279">
      <button onClick={() => onChange('PROCESSOR')} className={`flex items-center px-3 py-1.5 text-sm font-medium rounded-md transition-all ${currentRole === 'PROCESSOR' ? 'bg-white text-blue-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-280">
        <UserCog className="w-4 h-4 mr-2" data-id="element-281" />
        Processor View
      </button>
      <button onClick={() => onChange('MANAGER')} className={`flex items-center px-3 py-1.5 text-sm font-medium rounded-md transition-all ${currentRole === 'MANAGER' ? 'bg-white text-blue-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-282">
        <Users className="w-4 h-4 mr-2" data-id="element-283" />
        Manager View
      </button>
    </div>;
}